import en from './en';
import zh from './zh';

const translations = {
  en,
  zh
};

export default translations;



// WEBPACK FOOTER //
// ./locale/index.js